export default "__VITE_ASSET__Rxgah2zu__"